import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Result, Button } from 'antd';

function AccessDeniedPage() {
  const { t } = useTranslation();
  const history = useHistory();

  const handleGoBack = () => {
    history.push('/suite/dashboard');
  };

  return (
    <div
      className="app-container"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}
    >
      <Result
        status="403"
        title="403"
        subTitle={t('landing.accessDenied.message', 'Sorry, you do not have access to this application.')}
        extra={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <Button type="primary" onClick={handleGoBack}>
            {t('landing.accessDenied.backButton', 'Back to Dashboard')}
          </Button>
        }
      />
    </div>
  );
}

export default AccessDeniedPage;
